import styles from '../style.module.css';
import {useSelector} from "react-redux";
import LoadContent from "../../../components/LoadContent";
import React, {useRef} from "react";
import bannerImage from 'assets/about_us_banner.png';
import about_logo from 'assets/about_logo.png';
import lang from "../../../lang/lang";
import PhoneBlackSvg from "../../../assets/SVG/PhoneBlackIcon";
import ButtonArrowSvg from "../../../assets/SVG/ButtonArrowSvg";
import UseOutSideClick from "helpers/UseOutSideClick";
import FacebookSvg from "../../../assets/SVG/FacebookSvg";
import InstagramSvg from "../../../assets/SVG/InstagramSvg";
import WhatsappSvg from "../../../assets/SVG/WhatsappSvg";
import ViberSvg from "../../../assets/SVG/ViberSvg";
import BannerRotateItem from './BannerRotateItem'

export default function MainBanner({banner}) {

    const {currentLanguage} = useSelector(({main}) => main);

    const [showPhones, setShowPhones] = React.useState(false);

    const openedPhonesRef = useRef(null);

    UseOutSideClick(openedPhonesRef, () => setShowPhones(false));

    return (
        <div className={styles.main_banner}>
            {
                !banner ?
                    <LoadContent
                        containerClassName={styles.LoadContentGeneralBaner}
                    />
                    :
                    <img
                        alt={'about page banner'}
                        style={{
                            borderRadius: '20px'
                        }}
                        // src={
                        //     process.env.REACT_APP_STORAGE_URL +
                        //     banner["image_" + currentLanguage]
                        // }
                        src={bannerImage}
                    />
            }
            <div className={styles.banner_header}>
                <button
                    className={styles.banner_header_button}
                    onClick={() => window.history.back()}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="11" viewBox="0 0 6 11" fill="none">
                        <path d="M5.24996 0.75L0.75 5.25002L5.25 9.75002" stroke="#282828" strokeWidth="1.5"
                              strokeMiterlimit="16" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {lang[currentLanguage].back}
                </button>
                <img
                    src={about_logo}
                    alt={'about page brand logo'}
                    className={styles.about_logo}
                />
                <div className={styles.phone_social_box}>
                    <div className={styles.phones} ref={openedPhonesRef}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path
                                d="M10.2058 11.3733C10.866 11.4093 11.375 10.8715 11.375 10.2514V8.82728C11.3749 8.18427 10.8632 7.73009 10.3197 7.65198C9.84871 7.58437 9.40696 7.43784 9.1122 7.32205C8.69424 7.1579 8.18382 7.22795 7.83534 7.57644L6.2807 9.13108C4.56354 8.22155 3.15277 6.81099 2.24337 5.09371L3.79855 3.53968C4.14705 3.19117 4.2171 2.68078 4.05293 2.26277C3.93719 1.96804 3.79064 1.5263 3.72301 1.05529C3.64489 0.511776 3.19071 0.000105 2.54774 0H1.12365C0.503518 0 -0.0343042 0.509034 0.00171078 1.16915C0.302769 6.66749 4.70752 11.0722 10.2058 11.3733Z"
                                fill="white"/>
                        </svg>
                        <a
                            href="tel:010349944"
                            className={styles.phoneBtn}
                        >
                            010-34-99-44
                        </a>
                        <svg
                            onClick={() => setShowPhones(!showPhones)}
                            xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none"
                        >
                            <path d="M0.5 0.500029L4.00002 4L7.50002 0.5" stroke="white" strokeMiterlimit="16"
                                  strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {
                            showPhones && (
                                <div className={styles.phonesOpened}>
                                    <a className={styles.phoneBtn} href="tel:010349944">010-34-99-44</a>
                                    <a className={styles.phoneBtn} href="tel:010449968">010-44-99-68</a>
                                </div>
                            )
                        }
                    </div>
                    <div
                        className={styles.vertical_line}
                    />
                    <div className={styles.social_links}>
                        <a
                            href="https://www.facebook.com/people/VLV-Electronics/100064824965577/?mibextid=LQQJ4d"
                            aria-label="facebook"
                            className={styles.socLinks}
                        >
                            <FacebookSvg className={styles.socIcon}/>
                        </a>
                        <a
                            href="https://www.instagram.com/vlv_centre/"
                            aria-label="instagram"
                            className={styles.socLinks}
                        >
                            <InstagramSvg className={styles.socIcon}/>
                        </a>
                        <a
                            href="https://wa.me/37491296655" aria-label="whatsapp"
                            className={styles.socLinks}
                        >
                            <WhatsappSvg className={styles.socIcon}/>
                        </a>
                        <a
                            href="viber://chat?number=+37491296655/"
                            aria-label="viber"
                            className={styles.socLinks}
                        >
                            <ViberSvg className={styles.socIcon}/>
                        </a>
                    </div>
                </div>
            </div>
            <div className={styles.banner_title_box}>
                <h1>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                </h1>
            </div>
            <div className={styles.rotate_images_box}>
                <BannerRotateItem
                    value={'10000'}
                    text={'Lorem Ipsum is simply dummy text of'}
                    background = {'white'}
                    valueColor = {'black'}
                    textColor={'#28282899'}
                    rotate={12}
                />
                <BannerRotateItem
                    value={'10000$'}
                    text={'Lorem Ipsum is simply dummy text of'}
                    background = {'black'}
                    valueColor = {'white'}
                    textColor={'#FFFFFF'}
                    rotate={-15}
                />
                <BannerRotateItem
                    value={'20+'}
                    text={'Lorem Ipsum is simply dummy text of'}
                    background = {'white'}
                    valueColor = {'black'}
                    left={100}
                    textColor={'#28282899'}
                    rotate={28}
                />
            </div>
            <div className={styles.store_links}>
                <img
                    className={styles.ws_download_image}
                    src="https://vlv.am/public/images/download-apple-logo.svg"
                    alt="Download on the App Store"
                    onClick={() =>
                        window.open('https://apps.apple.com/am/app/vlv-centre/id6476923086', '_blank', 'noopener,noreferrer')
                    }
                />
                <img
                    className={styles.ws_download_image}
                    src="https://vlv.am/public/images/download-google-play.svg"
                    alt="Get it on Google Play"
                    onClick={() =>
                        window.open(
                            'https://play.google.com/store/apps/details?id=com.vlv&pcampaignid=web_share',
                            '_blank',
                            'noopener,noreferrer'
                        )
                    }
                />
            </div>
        </div>
    )
}